import { faBars, faXmark } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HTMLMotionProps, motion } from 'framer-motion'
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../Redux/store';
import { setSideBarOpen } from '../../../Redux/State/App';
import IconSVG from '../../../Assets/icon.svg?component';
import LanguageDropdown from '../LanguageDropdown';
import { useNavigate } from 'react-router-dom';

export interface SidebarProps extends HTMLMotionProps<'div'> { }

const Sidebar = (props: SidebarProps) => {

    const { children, ...restProps } = props

    const isOpen = useAppSelector((s) => s.app.sidebaropen)
    const dispatch = useAppDispatch()

    const navigate = useNavigate()
    const { t, i18n } = useTranslation();

    return (
        <>
            <motion.div
                {...restProps}
                initial={{ left: '-100%' }}
                animate={{ left: isOpen ? '0px' : '-100%' }}
                transition={{ duration: 0.4 }}
                className="fixed lg:static flex flex-col min-w-[100vw] sm:min-w-[23rem] lg:min-w-80 h-[100dvh] bg-light-100 z-[105] shadow-[0_3px_40px_#294D910F]"
            >

                <button
                    onClick={() => {
                        if (window.location.hash === "#node_MAIN") {
                            window.location.hash = "";
                        }
                        window.location.hash = "node_MAIN";
                    }}
                    className="opacity-0 focus:opacity-100 pointer-events-none fixed left-1 top-1 p-1 z-[20] rounded bg-brand font-bold text-white">
                    {t('toMain')}
                </button>

                <div className='flex justify-between p-4'>
                    <div className='flex gap-3 items-center'>
                        <IconSVG className='w-10 h-10 text-brand cursor-pointer' onClick={() => navigate(`/${i18n.language}/dashboard`)} />
                        <h1 className='font-bold font-app text-brand text-[22px] cursor-pointer whitespace-nowrap' onClick={() => navigate(`/${i18n.language}/dashboard`)}>D I G I P A S</h1>
                    </div>
                    <div className='flex items-center justify-center gap-1'>
                        <LanguageDropdown />

                        <div className='flex lg:hidden items-center justify-center'>
                            <div onClick={() => dispatch(setSideBarOpen(false))} className='flex items-center justify-center rounded-[0.4rem] transition-all hover:bg-accent hover:text-white cursor-pointer p-2'>
                                <FontAwesomeIcon className='w-6 h-6 p-1' icon={faXmark} />
                            </div>
                        </div>
                    </div>
                </div>

                {children}

            </motion.div>

            <div className='z-[103] lg:hidden absolute left-0 top-0  flex items-center p-4 justify-center'>
                <div onClick={() => dispatch(setSideBarOpen(true))} className='flex items-center justify-center bg-light-100 hover:bg-accent hover:text-white cursor-pointer p-2 rounded-[0.4rem] overflow-hidden shadow-md'>
                    <FontAwesomeIcon className='w-6 h-6 p-1' icon={faBars} />
                </div>
            </div>
        </>
    );
};

export default Sidebar;
